import { render, staticRenderFns } from "./DinnerList.vue?vue&type=template&id=4000d599&"
import script from "./DinnerList.vue?vue&type=script&lang=js&"
export * from "./DinnerList.vue?vue&type=script&lang=js&"
import style0 from "./DinnerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports